import { Descriptions, Divider, Drawer } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function MembersView({ onClose, open }) {
  const { userDetails } = useSelector((state) => state.fetch);
  const navigate = useNavigate();
 
  const items1 = [
    {
      key: "1",
      label: "ID Number",
      children: userDetails?.usrFirstname ?? "N/A",
    },
    {
      key: "5",
      label: "County",
      children: userDetails?.usrLastname ?? "N/A",
    },
    {
      key: "2",
      label: "Email",
      children: userDetails?.usrEmail ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: userDetails?.usrMobileNumber ?? "N/A",
    },
    {
      key: "4",
      label: "Phone",
      children: userDetails?.usrNationalId ?? "N/A",
    },
    {
      key: "6",
      label: "Registration Date",
      children: userDetails?.usrNationalId ?? "N/A",
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "Land Size",
      children: userDetails?.usrFirstname ?? "N/A",
    },
    {
      key: "5",
      label: "Water Source",
      children: userDetails?.usrLastname ?? "N/A",
    },
    {
      key: "2",
      label: "Major Crops",
      children: userDetails?.usrEmail ?? "N/A",
    },
  ];
  const items3 = [
    {
      key: "1",
      label: "Name",
      children: userDetails?.usrFirstname ?? "N/A",
    },

    {
      key: "2",
      label: "Phone",
      children: userDetails?.usrEmail ?? "N/A",
    },
  ];
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Member Infomation</div>
       
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Member Details"
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title="Farm Details"
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        <Descriptions
          title="Contact Person"
          column={1}
          colon={false}
          items={items3}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default MembersView;
